module.exports = __webpack_public_path__ + "img/LuckyDraw.ecd8f8f4.png";